import { createStyles } from '@mantine/core'

type StylesParams = {
  color?: string
  hasResult: boolean
}

export default createStyles(
  (theme, { color = 'blue', hasResult }: StylesParams) => {
    return {
      root: {
        display: 'block',
        position: 'relative',

        padding: 16,
        borderRadius: 16,
        backgroundColor: '#fff',
        backgroundImage: `radial-gradient(51.67% 100% at 100% 0%, ${theme.colors?.[color]?.[0]} 0%, rgba(227, 242, 255, 0) 100%)`,
        ...(!hasResult && {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: 8,
        }),
        [theme.fn.largerThan('sm')]: {
          padding: 24,
          minHeight: 200,
        },
      },
      info: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        ...(hasResult && {
          height: '100%',
          justifyContent: 'space-between',
        }),
      },
      topInfo: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 8,
        [theme.fn.smallerThan('sm')]: {
          alignItems: 'flex-start',
        },
        [theme.fn.largerThan('sm')]: {
          alignItems: 'center',
        },
      },
      header: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        [theme.fn.smallerThan('sm')]: {
          flexDirection: 'column',
          alignItems: 'flex-start',
        },
        [theme.fn.largerThan('sm')]: {
          paddingRight: 20,
        },
      },
      title: {},
      desc: {},
      img: {
        width: 24,
      },
      action: {
        display: 'flex',
        justifyContent: 'flex-end',
        ...(hasResult && {
          position: 'absolute',
          right: 16,
          bottom: 16,
          [theme.fn.largerThan('sm')]: {
            right: 24,
            bottom: 24,
          },
        }),
      },
      btn: {
        fontWeight: 'normal',
        color: theme.fn.primaryColor(),
        paddingRight: 12,
        [theme.fn.smallerThan('sm')]: {
          padding: 0,
          width: 20,
          height: 20,
        },
      },
      updatedBy: {
        position: 'absolute',
        right: 16,
        top: 15,
        whiteSpace: 'nowrap',
      },
      recalcBtn: {
        position: 'absolute',
        right: 0,
        bottom: 0,
      },
      tooltipBtn: {
        padding: 0,
        height: 'auto',
        position: 'absolute',
        right: 20,
        top: 24,
      },
    }
  },
)
